import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import InvestorInvestmentDetailBannerSC from './investor-investment-detail-banner.styled';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import { ReactComponent as LeftArrow } from '../../assets/img/svg/left-arrow.svg';
import { Link } from 'react-router-dom';
import { ROUTE_INVESTMENTS, ROUTE_SECONDARY_MARKET } from '../../constants';
import { SmallText, HeadingOne } from '../typography';
import InlineLoading from '../ui/inline-loading/inline-loading';
import Button from '../ui/button';
import WishmakerModal from '../ui/modal';
import SellModal from './sell-modal';
import TransferOfClaimModal from './transfer-of-claim-modal';
import SmsVerification from '../sms-verification';
import SuccessModal from '../success-modal';
import BodyText from '../typography/body-text';
import LoanStatus from './loan-status/loan-status';

const _InvestorInvestmentDetailBanner = ({
  sendSms,
  sellInvestmentToGuaranteeFund,
  createInvestmentOffer,
  transferClaim,
  investmentDetail,
  dashboardData,
  history,
  onSuccess,
}) => {
  const [isSellModalOpened, setIsSellModalOpened] = useState(false);
  const [isTransferModalOpened, setIsTransferModalOpened] = useState(false);
  const [isSmsModalOpened, setSmsModalOpened] = useState(false);
  const [isSuccessModalOpened, setSuccessModalOpened] = useState(false);
  const [additionalData, setAdditionalData] = useState({});
  const [isSmsCodeError, setIsSmsCodeError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [successModalType, setSuccessModalType] = useState('');
  const [falseLoading, setFalseLoading] = useState(true);

  const [guaranteeFundStep, setGuaranteeFundStep] = useState(1);
  const [guaranteeFundOfferId, setGuaranteeFundOfferId] = useState('');
  const [guaranteeFundDocuments, setGuaranteeFundDocuments] = useState([]);

  const [transferStep, setTransferStep] = useState(1);
  const [transferId, setTransferId] = useState('');
  const [transferDocuments, setTransferDocuments] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      setFalseLoading(false);
    }, 300);
  }, []);

  const openSellModal = () => {
    setIsSellModalOpened(true);
    setGuaranteeFundStep(1);
  };

  const openTransferModal = () => {
    setIsTransferModalOpened(true);
    setTransferStep(1);
  };

  const redirectToSecondaryMarket = () => {
    setSuccessModalOpened(false);
    setSuccessModalType('');
    history.push(ROUTE_SECONDARY_MARKET);
  };

  const onSmsSend = (smsType) => {
    switch (smsType) {
      case 'manual':
        sendSms({ type: 'offer-manually' });
        break;
      case 'automatic':
        sendSms({ type: 'offer-automatically' });
        break;
      case 'guarantee_fund':
        sendSms({ type: 'sell-gf' });
        break;
      case 'transfer':
        sendSms({ type: 'transfer' });
        break;
      default:
        break;
    }
  };

  const onCloseSuccess = () => {
    setSuccessModalOpened(false);
    setSuccessModalType('');
    onSuccess();
  };

  const onSellModalSubmit = (modalData) => {
    setAdditionalData(modalData);
    onSmsSend(modalData.type);
    setSmsModalOpened(true);
  };

  const onTransferOfClaimModalSubmit = (modalData) => {
    setAdditionalData(modalData);
    onSmsSend('transfer');
    setSmsModalOpened(true);
  };

  const onSmsModalSubmit = (smsModalData) => {
    const onBadSmsCode = () => {
      setIsSending(false);
      setIsSmsCodeError(true);
    };

    const onError = () => {
      setIsSending(false);
    };

    if (smsModalData.type === 'transfer') {
      const onSuccess = (data) => {
        setIsSending(false);

        if (transferStep <= 2 && data && data.transfer_id && data.documents) {
          setTransferId(data.transfer_id);
          setTransferDocuments(data.documents);
          setTransferStep(transferStep + 1);
          setSmsModalOpened(false);

          return;
        }

        setIsTransferModalOpened(false);
        setSmsModalOpened(false);
        setSuccessModalType('transfer');
        setSuccessModalOpened(true);
      };

      const transferSubmit = async () => {
        const payload = {
          sms_code: smsModalData.sms_code,
          step: transferStep,
          ...(transferId && { transfer_id: transferId }),
          ...(smsModalData.agreed !== undefined && { agreed: smsModalData.agreed }),
        };

        await transferClaim({
          data: payload,
          investmentId: investmentDetail.id,
          onSuccess,
          onBadSmsCode,
          onError,
        });
        setIsSending(true);
      };
      transferSubmit();
    } else if (smsModalData.type === 'guarantee_fund') {
      const onSuccess = (data) => {
        if (data && guaranteeFundStep <= 2) {
          if (data.gf_sale_id && data.documents) {
            setIsSending(false);
            setGuaranteeFundOfferId(data.gf_sale_id);
            setGuaranteeFundDocuments(data.documents);
            setGuaranteeFundStep(guaranteeFundStep + 1);
            setSmsModalOpened(false);
          }
        } else {
          setIsSending(false);
          setIsSellModalOpened(false);
          setSmsModalOpened(false);
          setSuccessModalType('guarantee_fund');
          setSuccessModalOpened(true);
        }
      };

      const sellToGuaranteeFund = async () => {
        let formattedData = {};
        if (guaranteeFundOfferId !== '') {
          formattedData = {
            sms_code: smsModalData.sms_code,
            step: guaranteeFundStep,
            gf_sale_id: guaranteeFundOfferId,
          };
        } else {
          formattedData = {
            sms_code: smsModalData.sms_code,
            step: guaranteeFundStep,
          };
        }

        await sellInvestmentToGuaranteeFund({
          data: formattedData,
          investment: investmentDetail.id,
          onSuccess,
          onBadSmsCode,
          onError,
        });
        setIsSending(true);
      };
      sellToGuaranteeFund();
    } else {
      const onSuccess = () => {
        setIsSending(false);
        setSmsModalOpened(false);
        setIsSellModalOpened(false);
        if (smsModalData.type === 'automatic') {
          setSuccessModalType('automatic');
          setSuccessModalOpened(true);
        } else {
          setSuccessModalType('manual');
          setSuccessModalOpened(true);
        }
      };

      const createOffer = async () => {
        await createInvestmentOffer({
          data: smsModalData,
          investment: investmentDetail.id,
          onSuccess,
          onBadSmsCode,
          onError,
        });
        setIsSending(true);
      };
      createOffer();
    }
  };

  function getStatusComponent() {
    if (investmentDetail.guestView) {
      return null;
    }

    if (investmentDetail.status.hideOfferButton === true) {
      return null;
    }

    return investmentDetail.status.saleStatus !== null ||
      investmentDetail.status.isTransferred === true ? (
      <div className="right-wrap">
        <div className="right-wrap-card sell-transaction status">
          <LoanStatus
            offerStatus={investmentDetail.status.saleStatus}
            isTransferred={investmentDetail.status.isTransferred}
            offer={investmentDetail.offer}
            investor={investmentDetail.investor}
          />
          {/* <SmallText className="bold white">
          <FormattedHTMLMessage
            id={`investor_loan_detail_${investmentDetail.status.saleStatus}`}
            defaultMessage={dlt[`investor_loan_detail_${investmentDetail.status.saleStatus}`]}
          />
        </SmallText> */}
        </div>
      </div>
    ) : (
      <div className="right-wrap">
        <div className="right-wrap-card sell-transaction">
          <SmallText className="grey">
            <FormattedHTMLMessage
              id="investor_loan_detail_sell_card_copy"
              defaultMessage={dlt['investor_loan_detail_sell_card_copy']}
            />
          </SmallText>
          <Button type="PRIMARY" size="MEDIUM" onClick={() => openSellModal()}>
            <FormattedMessage
              id="global_offer_to_sell"
              defaultMessage={dlt['global_offer_to_sell']}
            />
          </Button>
        </div>
        {investmentDetail.status.hideTransferButton ? null : (
          <div className="right-wrap-card transfer-of-claim">
            <SmallText className="grey">
              <FormattedHTMLMessage
                id="investor_loan_detail_transfer_of_claim_card_text"
                defaultMessage={dlt['investor_loan_detail_transfer_of_claim_card_text']}
              />
            </SmallText>
            <Button
              type="PRIMARY"
              size="MEDIUM"
              onClick={() => openTransferModal()}
              className="pulsing"
            >
              <FormattedMessage
                id="investor_loan_detail_transfer_of_claim_card_button"
                defaultMessage={dlt['investor_loan_detail_transfer_of_claim_card_button']}
              />
            </Button>
          </div>
        )}
      </div>
    );
  }

  if (Object.keys(investmentDetail).length <= 0 || falseLoading) {
    return (
      <InvestorInvestmentDetailBannerSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </InvestorInvestmentDetailBannerSC>
    );
  }
  return (
    <>
      <WishmakerModal
        isOpened={isSuccessModalOpened}
        onClose={() => onCloseSuccess()}
        className="special"
        withCross
      >
        <SuccessModal
          headlineText={
            successModalType === 'transfer'
              ? 'investor_loan_detail_transfer_of_claim_modal_success'
              : successModalType === 'guarantee_fund'
              ? 'investor_loan_detail_sell_modal_success_guarantee_fund_headline'
              : successModalType === 'automatic'
              ? 'investor_loan_detail_sell_modal_success_automatic_headline'
              : successModalType === 'manual'
              ? 'investor_loan_detail_sell_modal_success_manual_headline'
              : ''
          }
        >
          {successModalType === 'guarantee_fund' ? (
            <></>
          ) : successModalType === 'automatic' ? (
            <BodyText>
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_success_automatic_copy"
                defaultMessage={dlt['investor_loan_detail_sell_modal_success_automatic_copy']}
              />
            </BodyText>
          ) : successModalType === 'manual' ? (
            <>
              <BodyText>
                <FormattedHTMLMessage
                  id="investor_loan_detail_sell_modal_success_manual_copy"
                  defaultMessage={dlt['investor_loan_detail_sell_modal_success_manual_copy']}
                />
              </BodyText>
              <Button type="LINK" onClick={() => redirectToSecondaryMarket()}>
                <FormattedMessage
                  id="investor_loan_detail_sell_modal_success_manual_btn"
                  defaultMessage={dlt['investor_loan_detail_sell_modal_success_manual_btn']}
                />
              </Button>
              .
            </>
          ) : null}
        </SuccessModal>
      </WishmakerModal>
      <WishmakerModal
        isOpened={isSellModalOpened}
        onClose={() => setIsSellModalOpened(false)}
        className="special"
        withCross
      >
        <SellModal
          investmentDetail={investmentDetail}
          dashboardData={dashboardData}
          onSubmit={(modalData) => onSellModalSubmit(modalData)}
          activeStep={guaranteeFundStep}
          documents={guaranteeFundDocuments}
        />
      </WishmakerModal>
      <WishmakerModal
        isOpened={isTransferModalOpened}
        onClose={() => setIsTransferModalOpened(false)}
        className="special"
        withCross
      >
        <TransferOfClaimModal
          activeStep={transferStep}
          investmentDetail={investmentDetail}
          documents={transferDocuments}
          onSubmit={(modalData) => onTransferOfClaimModalSubmit(modalData)}
        />
      </WishmakerModal>
      <WishmakerModal
        isOpened={isSmsModalOpened}
        closeOnDocumentClick={false}
        onClose={() => setSmsModalOpened(false)}
        className="special"
        withCross={!isSending}
      >
        <SmsVerification
          onSubmit={(data) => onSmsModalSubmit(data)}
          additionalData={additionalData}
          isError={isSmsCodeError}
          isSending={isSending}
          onResend={(investType) => onSmsSend(investType)}
          onBadSms={() => setIsSmsCodeError(false)}
        />
      </WishmakerModal>
      <InvestorInvestmentDetailBannerSC>
        <div className="left-wrap">
          <Link
            className="back-to-repay"
            to={{ pathname: ROUTE_INVESTMENTS, state: history.location.state }}
          >
            <LeftArrow />
            <FormattedMessage
              id="menu_my_investments"
              defaultMessage={dlt['menu_my_investments']}
            />
          </Link>
          <div className="left-wrap--main-headline">
            <HeadingOne className="white">{investmentDetail.debtor.wmNumber}</HeadingOne>
          </div>
        </div>

        {getStatusComponent()}
      </InvestorInvestmentDetailBannerSC>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSms: ActionCreators.sendSms,
      sellInvestmentToGuaranteeFund: ActionCreators.sellInvestmentToGuaranteeFund,
      createInvestmentOffer: ActionCreators.createInvestmentOffer,
      transferClaim: ActionCreators.transferClaim,
    },
    dispatch
  );
};

const InvestorInvestmentDetailBanner = withRouter(
  connect(null, mapDispatchToProps)(_InvestorInvestmentDetailBanner)
);

export default InvestorInvestmentDetailBanner;
